<template>
    <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;height:100%;">
        <v-layout row>
            <v-flex>
                <v-card>
                    <v-card-title primary class="title" style="height:5%;width:100%;padding-top:5px;padding-bottom:5px;">{{selectedSystem}} KPI</v-card-title>
                    <v-card-actions style="height:95%;width:100%;padding-top:0px;padding-bottom:10px;">
                        <dx-data-grid class="grid" :data-source="gridData['kpi']" :show-column-headers="false" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true">
                            <dx-column data-field="engType" />
                            <dx-column data-field="kpi" format="percent"/>
                            <dx-sorting mode="none"/>
                        </dx-data-grid>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex d-flex md4>
                <v-card fill-height style="height:100%;width:100%;">
                    <v-card-title primary class="title" style="height:5%;width:100%;padding-top:5px;padding-bottom:5px;">{{selectedSystem}} Related Issues</v-card-title>
                    <v-card-actions fill-height style="height:95%;width:100%;padding-top:0px;padding-bottom:0px;">
                        <dx-data-grid class="grid" :data-source="issueData" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true" @cellClick="gridClick" @cellPrepared="cellPrepared">
                            <dx-column data-field="desc" caption="Issue Description"/>
                            <dx-column data-field="comp" caption="Component"/>
                            <dx-column data-field="issueCount" caption="Issue Counter"/>
                            <dx-column data-field="engCount" caption="Engine Counter"/>
                            <dx-column data-field="engType" caption="Engine Type"/>
                            <dx-column data-field="vessName" caption="Vessel"/>
                        </dx-data-grid>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex d-flex md6>
                <v-layout column>
                    <v-flex d-flex md6 style="max-height:50%;">
                        <v-layout row>
                            <v-flex d-flex md7>
                                <Chart v-bind:chartOptions="chartData['engIssues']" v-bind:title="selectedSystem+' Issues / Engine Type'" v-bind:active="active"/>
                            </v-flex>
                            <v-flex d-flex md5>
                                <Chart v-bind:chartOptions="chartData['compIssues']" v-bind:title="selectedSystem+' Issues / Component type'" v-bind:active="active"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex d-flex md6 style="max-height:50%;">
                        <v-layout row>
                            <v-flex d-flex md3>
                                <Chart v-bind:chartOptions="chartData['topIssues']" v-bind:title="'Top Issues'" v-bind:active="active"/>
                            </v-flex>
                            <v-flex d-flex md9>
                                <v-card>
                                    <Schematic v-bind:schematicSource="schematicSource" v-bind:points="points" v-bind:initWidth="initWidth" v-bind:initHeight="initHeight" v-bind:active="active"/>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import Chart from '../components/Chart'
    import Schematic from '../components/Schematic'
    import {DxDataGrid, DxColumn, DxPaging, DxScrolling, DxSorting} from 'devextreme-vue/data-grid';

    export default {
        name: "SubsystemView",
        components: {
            Chart,
            DxDataGrid,
            DxColumn,
            DxPaging,
            DxScrolling,
            Schematic
        },
        data() {
            return {
                chartData: {},
                gridData: {},
                compMapping: {
                    'Servo Oil': {
                        components: ["Servo Oil Rail", "VCU", "Exhaust Valve", "Servo oil pumps"],
                        points: [{x: 56, y: 540}, {x: 1001, y: 252}, {x: 1624, y: 295}, {x: 1293, y: 900}],
                        schematic: require('../assets/servo-oil-schematic-light.png'),
                        initWidth: 1820,
                        initHeight: 1134,
                        tag: 'so'
                    },
                    'Fuel Injection': {
                        components: ["Fuel Rail", "Injectors", "Fuel Pumps"],
                        points: [{x: 36, y: 565}, {x: 1285, y: 741}, {x: 1539, y: 312}],
                        schematic: require('../assets/fuel-injection-schematic-light.png'),
                        initWidth: 1820,
                        initHeight: 1134,
                        tag: 'fi'
                    },
                    'Scavenge Air': {
                        components: ["Scavenge Air Cooler", "Scavenge Ports", "Air Flaps", "Compressor", "Filter"],
                        schematic: require('../assets/scavenge-exhaust-schematic-light.png'),
                        points: [{x: 609, y: 860}, {x: 187, y: 836}, {x: 414, y: 815}, {x: 614, y: 640}, {x: 654, y: 473}],
                        initWidth: 910,
                        initHeight: 1134,
                        tag: 'sac'
                    },
                    'Exhaust Gas': {
                        components: ["Waste Gate", "Turbine"],
                        schematic: require('../assets/scavenge-exhaust-schematic-light.png'),
                        points: [{x: 459, y: 354}, {x: 444, y: 640}],
                        initWidth: 910,
                        initHeight: 1134,
                        tag: 'egs'
                    },
                    'Gas Admission': {
                        components: ["Gas Admission Valve Exhaust Side", "Gas Admission Valve Fuel Side", "Knock Sensor", "Piston Underside Sensor", "Pilot Fuel Injectors"],
                        schematic: require('../assets/gas-admission-schematic-light.png'),
                        points: [{x: 280, y: 350}, {x: 555, y: 350}, {x: 495, y: 220}, {x: 345, y: 495}, {x: 335, y: 180}],
                        initWidth: 910,
                        initHeight: 567,
                        tag: 'gas'
                    },
                    'Piston Running': {
                        components: ["Piston Rings", "Cylinder Liner"],
                        schematic: require('../assets/piston-schematic-light.png'),
                        points: [{x: 1053, y: 528}, {x: 693, y: 298}],
                        initWidth: 1820,
                        initHeight: 1134,
                        tag: 'pr'
                    }
                },
                schematicSource: require('../assets/servo-oil-schematic-light.png'),
                points: {},
                issueData: [],
                initWidth: 1820,
                initHeight: 1134
            }
        },
        computed: {},
        props: {
            active: Boolean,
            selectedSystem: String,
            subSystemData: Object
        },
        created() {
        },
        mounted() {
        },
        methods: {
            gridClick(e) {
                if ((e.column.dataField == "vessName") && (e.rowType != "header")) {
                    this.$emit('vesselSelected', e.value);
                }
            },
            cellPrepared(e) {
                if ((e.column.dataField == "vessName") && (e.rowType != "header")) {
                    e.cellElement.classList.add('clickable');
                }
            }
        },
        watch: {
            selectedSystem: function () {
                let selCompMap = this.compMapping[this.selectedSystem.replace(/\s+/g, ' ')];

                let engineTypes = Object.keys(this.subSystemData.engineTypes);

                this.$set(this.gridData, 'kpi', []);

                for (let i = 0; i < engineTypes.length; i++) {
                    this.gridData['kpi'].push({
                        engType: engineTypes[i],
                        kpi: this.subSystemData.engineTypes[engineTypes[i]][selCompMap.tag + '_KPI']
                    })
                }

                this.$set(this.chartData, 'engIssues', {
                    chart: {
                        height: 0,
                        zoomType: 'xy'
                    },
                    legend: {
                        enabled: false
                    },
                    xAxis: {
                        categories: engineTypes,
                        crosshair: true
                    },
                    yAxis: {
                        title: {
                            text: undefined
                        }
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: undefined
                    },
                    series: [{
                        type: 'column',
                        animation: false,
                        data: [],
                        states: {
                            hover: {
                                enabled: false
                            },
                            normal: {
                                animation: false
                            },
                            inactive: {
                                opacity: 1
                            }
                        }
                    }]
                });

                for (let i = 0; i < engineTypes.length; i++) {
                    this.chartData['engIssues'].series[0].data.push({
                        y: this.subSystemData.faultsEngineTypes[engineTypes[i]],
                        color: 'rgb(144,170,218)'
                    });
                }

                this.$set(this.chartData, 'compIssues', {
                    chart: {
                        height: 0,
                        zoomType: 'xy'
                    },
                    legend: {
                        enabled: false
                    },
                    xAxis: {
                        categories: selCompMap.components,
                        crosshair: true
                    },
                    yAxis: {
                        title: {
                            text: undefined
                        }
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: undefined
                    },
                    series: [{
                        type: 'column',
                        animation: false,
                        data: [],
                        states: {
                            hover: {
                                enabled: false
                            },
                            normal: {
                                animation: false
                            },
                            inactive: {
                                opacity: 1
                            }
                        }
                    }]
                });

                this.points = {};

                for (let i = 0; i < selCompMap.components.length; i++) {
                    let num = 0, clr = 0;

                    if (Object.keys(this.subSystemData.Components).includes(selCompMap.components[i]))
                        num = this.subSystemData.Components[selCompMap.components[i]];

                    if (num > 0) clr = 20;

                    this.chartData['compIssues'].series[0].data.push({
                        y: num,
                        color: 'rgb(144,170,218)'
                    });

                    let compPoint = {
                        x: selCompMap.points[i].x,
                        y: selCompMap.points[i].y,
                        color: clr
                    };

                    this.points[selCompMap.components[i]] = compPoint;
                }

                this.$set(this.chartData, 'topIssues', {
                    chart: {
                        height: 0,
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: undefined
                    },
                    plotOptions: {
                        pie: {
                            shadow: false,
                            center: ['50%', '50%'],
                            dataLabels: {
                                enabled: false
                            },
                        }
                    },
                    series: [{
                        type: 'pie',
                        animation: false,
                        data: [],
                        size: '100%',
                        innerSize: '70%',
                        states: {
                            hover: {
                                enabled: false
                            },
                            normal: {
                                animation: false
                            },
                            inactive: {
                                opacity: 1
                            }
                        }
                    }]
                });

                for (let i = 0; i < this.subSystemData.topFaults.length; i++) {
                    this.chartData['topIssues'].series[0].data.push({
                        y: Number(this.subSystemData.topFaults[i].percentage),
                        name: this.subSystemData.topFaults[i].description
                    });
                }

                this.issueData = [];

                for (let i = 0; i < this.subSystemData.faults.length; i++) {
                    let fault = this.subSystemData.faults[i];

                    this.issueData.push({
                        desc: fault.description,
                        comp: fault.component,
                        issueCount: fault.faultCounter,
                        engCount: fault.engCounter,
                        engType: fault.engType,
                        vessName: fault.vessel
                    });
                }

                this.schematicSource = selCompMap.schematic;
                this.initWidth = selCompMap.initWidth;
                this.initHeight = selCompMap.initHeight;
            }
        }
    }
</script>

<style scoped>

</style>
